import { render, staticRenderFns } from "./SummaryDateTable.vue?vue&type=template&id=08c90628"
import script from "./SummaryDateTable.vue?vue&type=script&lang=js"
export * from "./SummaryDateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports